/* ------------------------------------------------------------------------------
*
*  # Basic datatables
*
*  Specific JS code additions for loading datatables
*
* ---------------------------------------------------------------------------- */

$(function() {

  // Table setup
  // ------------------------------

  // Setting datatable defaults
  $.extend( $.fn.dataTable.defaults, {
      autoWidth: false,
      responsive: true,
      paginate: false,
      dom: '<"datatable-header"fl><"datatable-scroll"t><"datatable-footer"ip>',
      language: {
          search: '_INPUT_',
          searchPlaceholder: 'Filtrer...',
          lengthMenu: '<span>Afficher</span> _MENU_',
          paginate: { 'first': 'Premier', 'last': 'Dernier', 'next': '&rarr;', 'previous': '&larr;'},
          zeroRecords: 'Aucune entrée',
          infoEmpty: 'Aucune entrée ne correspond aux critères',
          emptyTable: 'Aucune entrée',
          info: 'Affichage des entrées _START_ à _END_ sur _TOTAL_',
          infoFiltered:"(filtrage sur _MAX_ entrées au total)"
      },
      drawCallback: function () {
          $(this).find('tbody tr').slice(-3).find('.dropdown, .btn-group').addClass('dropup');
      },
      preDrawCallback: function() {
          $(this).find('tbody tr').slice(-3).find('.dropdown, .btn-group').removeClass('dropup');
      }
  });

  // Basic datatable
  /*$('.datatable').each(function()
  {
    var $table = $(this);
    
    var options = {};
    // Alternative pagination
    if($table.hasClass('datatable-pagination')) {
      options.pagingType = "simple";
    }
    // Datatable with saving state
    if($table.hasClass('datatable-save-state')) {
      options.stateSave = true;
    }
    // Scrollable datatable
    if($table.hasClass('datatable-scroll-y')) {
      options.autoWidth = true;
      options.scrollY = 400;
    }
    // Enable Select2 select for the length option
    if($table.hasClass('dataTables_length')) {
      $table.find('select').select2({
        minimumResultsForSearch: Infinity,
        width: 'auto'
      });
    }
    // Individual column searching with text inputs
    if($table.hasClass('datatable-column-search-inputs')) {
      var $tfoot_html = '<tfoot><tr>';
      var $thead = $table.find('thead').first();
      $thead.find('tr th').each(function(){
        var $th = $(this);
        if(!$th.hasClass('no-column-search-input')) {
          $tfoot_html += '<td><input type="text" class="form-control input-sm" placeholder="Filter par ' + $th.text() + '" /></td>';
        } else {
          $tfoot_html += '<td></td>';
        }
      });
      $tfoot_html += '</tr></tfoot>';
      $table.append($tfoot_html);
    }
    // Def columns config
    var columnDefs = [];
    $ths = $table.find("thead tr th");
    if($ths.filter('.no-sorting').length > 0) {
      var columnDef = {
        orderable: false,
        targets: []
      };
      $ths.filter('.no-sorting').each(function() {
        columnDef.targets.push($(this).index());
      });
      columnDefs.push(columnDef);
    }
    options.columnDefs = columnDefs;
    var table = $table.DataTable(options);
    
    if($table.hasClass('datatable-column-search-inputs')) {
      table.columns().every( function () {
          var that = this;
          $('input', this.footer()).on('keyup change', function () {
              that.search(this.value).draw();
          });
      });
    }
  });*/
  
  $('.datatable').DataTable({
    paging: false,
    info: false,
    filter: false,
    order: [],
    columnDefs: [
      {
        targets: 'no-sorting',
        orderable: false
      }
    ]
  });
    
});